import { isValidElement } from 'react';
import { createStore } from '../../core/store.mjs';
import { generateDefaultState } from '../util.mjs';

var createOpenerStore = function createOpenerStore() {
  var store = createStore(function (set) {
    var defaultState = generateDefaultState(set);
    return Object.assign(Object.assign({}, defaultState), {
      open: function open(item) {
        return defaultState.open( /*#__PURE__*/isValidElement(item) || typeof item === "function" ? {
          element: item
        } : item);
      }
    });
  });
  return Object.assign(Object.assign({}, store), {
    open: store.getState().open,
    close: store.getState().close,
    closeAll: store.getState().closeAll
  });
};

export { createOpenerStore };
